let limitsOnCart: CurrencyLimits | null = null;

type CurrencyLimits = Record<string, number>; // string is ISO 3-Letter Currency Code

export const setLimitsOnCart = (value: CurrencyLimits) => {
  limitsOnCart = value;
};

export const getLimitsOnCart = () => limitsOnCart;
